export type TNavigationItem = {
  path: string;
  title: string;
};

export type TNavigationItems = Array<{
  path: string;
  title: string;
  items: TNavigationItem[];
}>;

export const navigationGroups: TNavigationItems = [
  {
    path: '/activity',
    title: 'Activity',
    items: [
      { path: '/day_cruising', title: 'Day Cruising' },
      { path: '/overnight_cruising', title: 'Overnight Cruising' },
      { path: '/sailing', title: 'Sailing' },
      { path: '/watersports', title: 'Watersports' },
    ],
  },
  {
    path: '/category',
    title: 'Category',
    items: [
      { path: '/antique-and-classic-boats', title: 'Antique and Classic Boats' },
      { path: '/catamaran-boats', title: 'Catamaran Boats' },
      { path: '/cruiser-boats', title: 'Cruiser Boats' },
      { path: '/cruiser-racer-boats', title: 'Cruiser/Racer Boats' },
    ],
  },
  {
    path: '/type',
    title: 'Type',
    items: [
      { path: '/sail', title: 'Sail' },
      { path: '/power', title: 'Power' },
    ],
  },
  {
    path: '/hull-type',
    title: 'Hull Type',
    items: [
      { path: '/catamaran', title: 'Catamaran' },
      { path: '/monohull', title: 'Monohull' },
      { path: '/trimaran', title: 'Trimaran' },
    ],
  },
];
